import { setTaskManagerTabs } from '../../store/tabsStore';

// Cap on undo/redo depth per open board. Bounded so history never grows without
// limit; tune here if a deeper/shallower history is wanted.
export const MAX_HISTORY = 50;

// Push onto a history stack, dropping the oldest entry once it exceeds the cap.
// Pure helper shared by every push site so the cap invariant lives in one place.
export function pushCapped(stack, item) {
  stack.push(item);
  if (stack.length > MAX_HISTORY) stack.shift();
}

export function newId() {
  return (crypto.randomUUID && crypto.randomUUID()) || `id-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function randomHex() {
  return `#${Math.floor(Math.random() * 0xffffff).toString(16).padStart(6, '0')}`;
}

export function randomGradient() {
  return `linear-gradient(135deg, ${randomHex()}, ${randomHex()})`;
}

/** Updates the tab strip label for one board tab (if open) to match a rename. */
export function relabelTaskManagerBoardTab(boardId, label) {
  setTaskManagerTabs((prev) => prev.map((t) => (t.boardId === boardId ? { ...t, label } : t)));
}
